/* Do not edit directly — generated by scripts/tokens/build.mjs */

export const resolvedThemes = {
  light: {
    neutralBackgroundBase: "#FFFFFF",
    neutralBackgroundMedium: "#ECEEF0",
    neutralBackground: "#696A6A14",
    neutralBackgroundHover: "#696A6A1F",
    neutralBackgroundActive: "#696A6A29",
    neutralBackgroundExtraDark: "#1F2123",
    neutralText: "#1F2123",
    neutralTextWeak: "#696A6A",
    neutralTextDisabled: "#AAAAAA",
    neutralBorder: "#DFE0E2",
    neutralBorderMedium: "#AAAAAA",
    neutralScrim: "#1F21231A",
    neutralBackgroundTransparent: "#FFFFFF00",
    neutralBorderStrong: "#8A8A8A",
    primaryAction: "#2D6E8D",
    primaryActionHover: "#335969",
    primaryActionActive: "#245065",
    primaryBackground: "#2D6E8D1F",
    primaryBackgroundMedium: "#2D6E8D33",
    primaryBackgroundActive: "#2D6E8D3D",
    primaryBackgroundStrong: "#2D6E8D",
    primaryBackgroundStrongHover: "#335969",
    primaryBackgroundStrongActive: "#245065",
    primaryTextStrong: "#FFFFFF",
    primaryText: "#2D6E8D",
    primaryTextHover: "#335969",
    primaryBorder: "#2D6E8D",
    primaryTextStrongHover: "#D9E5EA",
    primaryTextStrongActive: "#BCD1DB",
    alertBackground: "#C5372E1F",
    alertBackgroundMedium: "#C5372E33",
    alertBackgroundActive: "#C5372E3D",
    alertBackgroundStrong: "#C5372E",
    alertBackgroundStrongHover: "#A83129",
    alertBackgroundStrongActive: "#8B2B25",
    alertText: "#A83129",
    alertTextHover: "#8B2B25",
    alertBorder: "#C5372E",
    warningBackground: "#E472251F",
    warningBackgroundMedium: "#E4722533",
    warningBackgroundActive: "#E472253D",
    warningBackgroundStrong: "#E47225",
    warningBackgroundStrongHover: "#C26222",
    warningBackgroundStrongActive: "#FAE6D8",
    warningText: "#C26222",
    warningTextHover: "#FAE6D8",
    warningBorder: "#E47225",
    successBackground: "#1E8E5E1F",
    successBackgroundMedium: "#1E8E5E33",
    successBackgroundActive: "#1E8E5E3D",
    successBackgroundStrong: "#1E8E5E",
    successBackgroundStrongHover: "#1C7A52",
    successBackgroundStrongActive: "#1A6645",
    successText: "#1C7A52",
    successTextHover: "#1A6645",
    successBorder: "#1E8E5E",
    datavizQualitative121: "#2D6E8D",
    datavizQualitative122: "#EEA676",
    datavizQualitative123: "#2F54EB",
    datavizQualitative124: "#9E9DAF",
    datavizQualitative125: "#43A047",
    datavizQualitative126: "#DA7973",
    datavizQualitative127: "#7BA4B7",
    datavizQualitative128: "#E47225",
    datavizQualitative129: "#7C93F2",
    datavizQualitative1210: "#656380",
    datavizQualitative1211: "#89C38B",
    datavizQualitative1212: "#C52B20",
    datavizQualitative41: "#2D6E8D",
    datavizQualitative42: "#EEA676",
    datavizQualitative43: "#2F54EB",
    datavizQualitative44: "#9E9DAF",
    datavizQualitative211: "#7BA4B7",
    datavizQualitative212: "#E47225",
    datavizQualitative221: "#7C93F2",
    datavizQualitative222: "#656380",
    datavizSequential711: "#CDD6FA",
    datavizSequential712: "#A6B5F6",
    datavizSequential713: "#7C93F2",
    datavizSequential714: "#5473EF",
    datavizSequential715: "#2F54EB",
    datavizSequential716: "#2847C8",
    datavizSequential717: "#213CA7",
    datavizSequential721: "#CDDCE4",
    datavizSequential722: "#A5C1CE",
    datavizSequential723: "#7BA4B7",
    datavizSequential724: "#5388A2",
    datavizSequential725: "#2D6E8D",
    datavizSequential726: "#265E78",
    datavizSequential727: "#204E64",
    datavizSequential731: "#F9DDCB",
    datavizSequential732: "#F3C2A1",
    datavizSequential733: "#EEA676",
    datavizSequential734: "#E98B4C",
    datavizSequential735: "#E47225",
    datavizSequential736: "#C2611F",
    datavizSequential737: "#A2511A",
    datavizSequential741: "#F9DDCB",
    datavizSequential742: "#D0B883",
    datavizSequential743: "#A5AE75",
    datavizSequential744: "#79A175",
    datavizSequential745: "#4F9079",
    datavizSequential746: "#2F797B",
    datavizSequential747: "#204E64",
    datavizDiverging911: "#2D6E8D",
    datavizDiverging912: "#5388A2",
    datavizDiverging913: "#7BA4B7",
    datavizDiverging914: "#A5C1CE",
    datavizDiverging915: "#DADAE1",
    datavizDiverging916: "#F3C2A1",
    datavizDiverging917: "#EEA676",
    datavizDiverging918: "#E98B4C",
    datavizDiverging919: "#E47225",
    datavizDiverging921: "#2F54EB",
    datavizDiverging922: "#5473EF",
    datavizDiverging923: "#7C93F2",
    datavizDiverging924: "#A6B5F6",
    datavizDiverging925: "#DADAE1",
    datavizDiverging926: "#E6A49F",
    datavizDiverging927: "#DA7973",
    datavizDiverging928: "#CF5148",
    datavizDiverging929: "#C52B20",
    focusRing: "#4F859F",
    standoutBackground: "#F9A71C",
    standoutBackgroundHover: "#FAB540",
    standoutBackgroundActive: "#FBC365",
    standoutText: "#17315A",
    buttonPrimaryStrong: "#2D6E8D",
    buttonPrimaryStrongHover: "#335969",
    buttonPrimaryStrongActive: "#245065",
    buttonDestructiveStrong: "#C5372E",
    buttonDestructiveStrongHover: "#A83129",
    buttonDestructiveStrongActive: "#8B2B25",
    buttonOnStrong: "#FFFFFF",
    badgeFill: "#17315A",
  },
  dark: {
    neutralBackgroundBase: "#1F2123",
    neutralBackgroundMedium: "#383A3B",
    neutralBackground: "#AAAAAA1F",
    neutralBackgroundHover: "#AAAAAA29",
    neutralBackgroundActive: "#AAAAAA33",
    neutralBackgroundExtraDark: "#FFFFFF",
    neutralText: "#FFFFFF",
    neutralTextWeak: "#AAAAAA",
    neutralTextDisabled: "#696A6A",
    neutralBorder: "#515253",
    neutralBorderMedium: "#696A6A",
    neutralScrim: "#FFFFFF1A",
    neutralBackgroundTransparent: "#FFFFFF00",
    neutralBorderStrong: "#8A8A8A",
    primaryAction: "#77A5BB",
    primaryActionHover: "#82A8BB",
    primaryActionActive: "#96B6C6",
    primaryBackground: "#5C91AB29",
    primaryBackgroundMedium: "#5C91AB33",
    primaryBackgroundActive: "#5C91AB47",
    primaryBackgroundStrong: "#77A5BB",
    primaryBackgroundStrongHover: "#82A8BB",
    primaryBackgroundStrongActive: "#96B6C6",
    primaryTextStrong: "#1F2123",
    primaryText: "#77A5BB",
    primaryTextHover: "#82A8BB",
    primaryBorder: "#77A5BB",
    primaryTextStrongHover: "#1C3440",
    primaryTextStrongActive: "#204253",
    alertBackground: "#CE574F1F",
    alertBackgroundMedium: "#CE574F33",
    alertBackgroundActive: "#CE574F3D",
    alertBackgroundStrong: "#CE574F",
    alertBackgroundStrongHover: "#D87771",
    alertBackgroundStrongActive: "#E29B96",
    alertText: "#D87771",
    alertTextHover: "#E29B96",
    alertBorder: "#CE574F",
    warningBackground: "#E889481F",
    warningBackgroundMedium: "#E8894833",
    warningBackgroundActive: "#E889483D",
    warningBackgroundStrong: "#E88948",
    warningBackgroundStrongHover: "#ED9F6B",
    warningBackgroundStrongActive: "#613619",
    warningText: "#ED9F6B",
    warningTextHover: "#613619",
    warningBorder: "#E88948",
    successBackground: "#42A0781F",
    successBackgroundMedium: "#42A07833",
    successBackgroundActive: "#42A0783D",
    successBackgroundStrong: "#42A078",
    successBackgroundStrongHover: "#66B292",
    successBackgroundStrongActive: "#8EC6AE",
    successText: "#66B292",
    successTextHover: "#8EC6AE",
    successBorder: "#42A078",
    datavizQualitative121: "#7BA4B7",
    datavizQualitative122: "#E47225",
    datavizQualitative123: "#7C93F2",
    datavizQualitative124: "#656380",
    datavizQualitative125: "#89C38B",
    datavizQualitative126: "#C52B20",
    datavizQualitative127: "#2D6E8D",
    datavizQualitative128: "#EEA676",
    datavizQualitative129: "#2F54EB",
    datavizQualitative1210: "#9E9DAF",
    datavizQualitative1211: "#43A047",
    datavizQualitative1212: "#DA7973",
    datavizQualitative41: "#7BA4B7",
    datavizQualitative42: "#E47225",
    datavizQualitative43: "#7C93F2",
    datavizQualitative44: "#656380",
    datavizQualitative211: "#2D6E8D",
    datavizQualitative212: "#EEA676",
    datavizQualitative221: "#2F54EB",
    datavizQualitative222: "#9E9DAF",
    datavizSequential711: "#213CA7",
    datavizSequential712: "#2847C8",
    datavizSequential713: "#2F54EB",
    datavizSequential714: "#5473EF",
    datavizSequential715: "#7C93F2",
    datavizSequential716: "#A6B5F6",
    datavizSequential717: "#CDD6FA",
    datavizSequential721: "#204E64",
    datavizSequential722: "#265E78",
    datavizSequential723: "#2D6E8D",
    datavizSequential724: "#5388A2",
    datavizSequential725: "#7BA4B7",
    datavizSequential726: "#A5C1CE",
    datavizSequential727: "#CDDCE4",
    datavizSequential731: "#A2511A",
    datavizSequential732: "#C2611F",
    datavizSequential733: "#E47225",
    datavizSequential734: "#E98B4C",
    datavizSequential735: "#EEA676",
    datavizSequential736: "#F3C2A1",
    datavizSequential737: "#F9DDCB",
    datavizSequential741: "#A2511A",
    datavizSequential742: "#D0B883",
    datavizSequential743: "#A5AE75",
    datavizSequential744: "#79A175",
    datavizSequential745: "#4F9079",
    datavizSequential746: "#2F797B",
    datavizSequential747: "#CDDCE4",
    datavizDiverging911: "#7BA4B7",
    datavizDiverging912: "#5388A2",
    datavizDiverging913: "#2D6E8D",
    datavizDiverging914: "#265E78",
    datavizDiverging915: "#48465B",
    datavizDiverging916: "#C2611F",
    datavizDiverging917: "#E47225",
    datavizDiverging918: "#E98B4C",
    datavizDiverging919: "#EEA676",
    datavizDiverging921: "#7C93F2",
    datavizDiverging922: "#5473EF",
    datavizDiverging923: "#2F54EB",
    datavizDiverging924: "#2847C8",
    datavizDiverging925: "#48465B",
    datavizDiverging926: "#A7251B",
    datavizDiverging927: "#C52B20",
    datavizDiverging928: "#CF5148",
    datavizDiverging929: "#DA7973",
    focusRing: "#709CB1",
    standoutBackground: "#F9A71C",
    standoutBackgroundHover: "#DD9B2C",
    standoutBackgroundActive: "#D29223",
    standoutText: "#17315A",
    buttonPrimaryStrong: "#2D6E8D",
    buttonPrimaryStrongHover: "#335969",
    buttonPrimaryStrongActive: "#245065",
    buttonDestructiveStrong: "#C5372E",
    buttonDestructiveStrongHover: "#A83129",
    buttonDestructiveStrongActive: "#8B2B25",
    buttonOnStrong: "#FFFFFF",
    badgeFill: "#2D6E8D",
  },
} as const;

export const resolvedTypography = {
  display2: {
    fontFamily: "Public Sans",
    fontSize: "40px",
    lineHeight: "56px",
    fontWeight: 600,
    letterSpacing: "-0.8px",
  },
  display1: {
    fontFamily: "Public Sans",
    fontSize: "48px",
    lineHeight: "52px",
    fontWeight: 600,
    letterSpacing: "-0.96px",
  },
  h1Sb: {
    fontFamily: "Public Sans",
    fontSize: "20px",
    lineHeight: "24px",
    fontWeight: 600,
    letterSpacing: "-0.4px",
  },
  h1: {
    fontFamily: "Public Sans",
    fontSize: "20px",
    lineHeight: "24px",
    fontWeight: 500,
    letterSpacing: "-0.4px",
  },
  h2Sb: {
    fontFamily: "Public Sans",
    fontSize: "18px",
    lineHeight: "24px",
    fontWeight: 600,
    letterSpacing: "-0.36px",
  },
  h2: {
    fontFamily: "Public Sans",
    fontSize: "18px",
    lineHeight: "24px",
    fontWeight: 500,
    letterSpacing: "-0.36px",
  },
  h3Sb: {
    fontFamily: "Public Sans",
    fontSize: "16px",
    lineHeight: "24px",
    fontWeight: 600,
    letterSpacing: "-0.32px",
  },
  h3: {
    fontFamily: "Public Sans",
    fontSize: "16px",
    lineHeight: "24px",
    fontWeight: 500,
    letterSpacing: "-0.32px",
  },
  h4Sb: {
    fontFamily: "Public Sans",
    fontSize: "14px",
    lineHeight: "16px",
    fontWeight: 600,
    letterSpacing: "-0.14px",
  },
  h4: {
    fontFamily: "Public Sans",
    fontSize: "14px",
    lineHeight: "16px",
    fontWeight: 500,
    letterSpacing: "-0.14px",
  },
  h5Sb: {
    fontFamily: "Public Sans",
    fontSize: "13px",
    lineHeight: "16px",
    fontWeight: 600,
    letterSpacing: "0px",
  },
  h5: {
    fontFamily: "Public Sans",
    fontSize: "13px",
    lineHeight: "16px",
    fontWeight: 500,
    letterSpacing: "0px",
  },
  actions14Sb: {
    fontFamily: "Public Sans",
    fontSize: "14px",
    lineHeight: "20px",
    fontWeight: 600,
    letterSpacing: "0px",
  },
  actions12Sb: {
    fontFamily: "Public Sans",
    fontSize: "12px",
    lineHeight: "16px",
    fontWeight: 600,
    letterSpacing: "0px",
  },
  body12: {
    fontFamily: "Public Sans",
    fontSize: "12px",
    lineHeight: "14px",
    fontWeight: 400,
    letterSpacing: "0px",
  },
  body14: {
    fontFamily: "Public Sans",
    fontSize: "14px",
    lineHeight: "16px",
    fontWeight: 400,
    letterSpacing: "0px",
  },
  body14Sb: {
    fontFamily: "Public Sans",
    fontSize: "14px",
    lineHeight: "16px",
    fontWeight: 600,
    letterSpacing: "0px",
  },
  body14M: {
    fontFamily: "Public Sans",
    fontSize: "14px",
    lineHeight: "16px",
    fontWeight: 500,
    letterSpacing: "0px",
  },
  body12M: {
    fontFamily: "Public Sans",
    fontSize: "12px",
    lineHeight: "14px",
    fontWeight: 500,
    letterSpacing: "0px",
  },
  bodySmall: {
    fontFamily: "Public Sans",
    fontSize: "11px",
    lineHeight: "14px",
    fontWeight: 400,
    letterSpacing: "0px",
  },
  bodyOverline: {
    fontFamily: "Public Sans",
    fontSize: "10px",
    lineHeight: "12px",
    fontWeight: 400,
    letterSpacing: "0.8px",
  },
  bodyFootnote: {
    fontFamily: "Public Sans",
    fontSize: "8px",
    lineHeight: "12px",
    fontWeight: 400,
    letterSpacing: "0px",
  },
  paragraphLargeM: {
    fontFamily: "Public Sans",
    fontSize: "16px",
    lineHeight: "24px",
    fontWeight: 600,
    letterSpacing: "0px",
  },
  paragraphLarge: {
    fontFamily: "Public Sans",
    fontSize: "16px",
    lineHeight: "24px",
    fontWeight: 400,
    letterSpacing: "0px",
  },
  paragraphMediumM: {
    fontFamily: "Public Sans",
    fontSize: "14px",
    lineHeight: "20px",
    fontWeight: 600,
    letterSpacing: "0px",
  },
  paragraphMedium: {
    fontFamily: "Public Sans",
    fontSize: "14px",
    lineHeight: "20px",
    fontWeight: 400,
    letterSpacing: "0px",
  },
  paragraphSmallM: {
    fontFamily: "Public Sans",
    fontSize: "12px",
    lineHeight: "16px",
    fontWeight: 600,
    letterSpacing: "0px",
  },
  paragraphSmall: {
    fontFamily: "Public Sans",
    fontSize: "12px",
    lineHeight: "16px",
    fontWeight: 400,
    letterSpacing: "0px",
  },
} as const;
